import React from 'react';
import { motion } from 'framer-motion';

/**
 * Splits a heading into words and reveals them with a staggered
 * clip-path wipe + rise, for a cinematic section-title feel.
 * Pass the gradient word(s) as `accent` to render them with .text-gradient.
 */
const RevealHeading = ({ text, accent, as: Tag = 'h2', className = '' }) => {
  const words = text.split(' ');

  const container = {
    hidden: {},
    visible: {
      transition: { staggerChildren: 0.08 },
    },
  };

  const word = {
    hidden: { y: '110%', opacity: 0 },
    visible: {
      y: '0%',
      opacity: 1,
      transition: { duration: 0.7, ease: [0.16, 1, 0.3, 1] },
    },
  };

  return (
    <Tag className={className}>
      <motion.span
        variants={container}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.6 }}
        className="inline-block"
      >
        {words.map((w, i) => (
          <span key={i} className="inline-block overflow-hidden align-bottom pb-1 mr-[0.25em]">
            <motion.span variants={word} className="inline-block">
              {w}
            </motion.span>
          </span>
        ))}
        {accent && (
          <span className="inline-block overflow-hidden align-bottom pb-1">
            <motion.span variants={word} className="inline-block text-gradient">
              {accent}
            </motion.span>
          </span>
        )}
      </motion.span>
    </Tag>
  );
};

export default RevealHeading;
